import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

@connect(state => ({
    totalCount : state.teamblog.item.totalCount,
    searchKeyword: state.teamblog.condition.searchKeyword,
    role: state.teamblog.condition.role,
}), dispatch => ({
}))
class TeamBlogTitle extends Component {

    render() {

        const { role, searchKeyword, totalCount} = this.props;

        if(role!== '' && role !== 'all'){

            let label;

            if (role === 'owner')
                label = '소유자';
            else if (role === 'manager')
                label = '관리자';
            else if (role === 'editor')
                label = '편집자';
            else if (role === 'writer')
                label = '필자';

            return (
                <h3 className="tit_cont">
                    <span className="txt_result">{label} </span>
                    <span className="txt_count"> {totalCount}</span>
                </h3>);


        }else if(searchKeyword && searchKeyword !== ''){

            return (
                <h3 className="tit_cont">
                    <span className="txt_result">{searchKeyword}</span> 검색결과
                    <span className="txt_count">{totalCount}</span>
                    <Link to={"?"} className="link_back">
                        <span className="ico_blog ico_back">검색 전으로 돌아가기</span>
                    </Link>
                </h3>
            );
        }else{

            return (
                <h3 className="tit_cont">
                    활동 중인 멤버
                    <span className="txt_count"> {totalCount}</span>
                </h3>
            );
        }
    }
}

export default TeamBlogTitle;
